/**
 * How each Recents status reads: its word, glyph and tone.
 *
 * @module components/home/recentThreadStatus
 */
import {
  AlarmClockIcon,
  CircleAlertIcon,
  CircleCheckIcon,
  CircleDashedIcon,
  EyeIcon,
  MessageCircleQuestionIcon,
  ShieldQuestionIcon,
} from "lucide-react";
import type { ComponentType } from "react";

import type { RecentStatusKind } from "./HomeSidebarRecents.logic";

export interface RecentStatusMeta {
  readonly label: string;
  readonly Icon: ComponentType<{ className?: string; strokeWidth?: number }>;
  readonly className: string;
}

export const RECENT_STATUS_META: Record<RecentStatusKind, RecentStatusMeta> = {
  approval: { label: "Approval", Icon: ShieldQuestionIcon, className: "text-warning-foreground" },
  input: { label: "Input", Icon: MessageCircleQuestionIcon, className: "text-indigo-600 dark:text-indigo-300" },
  working: { label: "Working", Icon: CircleDashedIcon, className: "text-info-foreground" },
  monitoring: { label: "Monitoring", Icon: EyeIcon, className: "text-muted-foreground" },
  failed: { label: "Failed", Icon: CircleAlertIcon, className: "text-error-foreground" },
  woke: { label: "Woke", Icon: AlarmClockIcon, className: "text-warning-foreground" },
  done: { label: "Done", Icon: CircleCheckIcon, className: "text-success-foreground" },
};
